import { ElementType } from "react";
import config from "config";
// ui
import { Link, IconButton } from "@chakra-ui/react";

interface PodcastIconButtonProps {
  color?: string;
  name: string;
  Icon: ElementType;
  margin?: string;
  height?: string;
  width?: string;
  label: string;
}

export const PodcastIconButton = ({ name, Icon, color = "inherit", margin, height, width, label }: PodcastIconButtonProps) => {
  const configName = config[name];
  const iconLink = {
    twitterName: `https://twitter.com/${configName}`,
    discordName: `https://discord.com/${configName}`,
    telegramName: `https://telegram.com/${configName}`,
    githubName: `https://github.com/${configName}`
  }[name];
  return (
    <>
      {configName && (
        <IconButton
          as={Link}
          href={iconLink}
          icon={<Icon width={width} height={height} />}
          aria-label={label}
          bg="transparent"
          _hover={{ bg: "transparent" }}
          target="_blank"
          mr={margin}
          color={color}
        />
      )}
    </>
  );
};
